module.exports = require('./helpers/bundle-url').getBundleURL('dKtRO') + "logo-dark.eefe0b7f.svg";